// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zzvc","col":"styles_col__1RSPb","actions":"styles_actions__1GmwU","conflict":"styles_conflict__3Ffo9"};